export const UserRegistrationStatus = {
  NEW: 'NEW',
  REGISTERED: 'REGISTERED',
  VERIFIED: 'VERIFIED',
} as const;
